/**
 * CSV Export Feature Hook
 *
 * Handles CSV file download.
 */

import { useCallback } from 'react';
import { useExportCsv } from '@/entities/account';
import { logger } from '@/shared/lib';
import type { CsvExportState } from './types';

export const useCsvExport = () => {
  const exportMutation = useExportCsv();

  const handleExport = useCallback(async () => {
    try {
      await exportMutation.mutateAsync(undefined);
    } catch (error) {
      logger.error('CSV export failed:', error);
    }
  }, [exportMutation]);

  const state: CsvExportState = {
    isExporting: exportMutation.isPending,
    handleExport,
  };

  return state;
};
